class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.toggles = this.querySelectorAll('[data-collapsible-toggle]');
    this.indicator = this.querySelector('[data-collapsible-indicator]');
    this.content = this.querySelector('[data-collapsible-content]');
    this.inner = this.querySelector('[data-collapsible-inner]');

    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const expanded = this.indicator.getAttribute('aria-expanded') === 'true';
        const hidden = this.content.getAttribute('aria-hidden') === 'true';
        this.indicator.setAttribute('aria-expanded', !expanded);
        this.content.setAttribute('aria-hidden', !hidden);
      });
    });
  }

  connectedCallback() {
    this.content.setAttribute('style', `--collapsible-height: ${this.content.scrollHeight}px`);

    const myObserver = new ResizeObserver(entries => {
      // this will get called whenever div dimension changes
       entries.forEach(entry => {
        this.content.setAttribute('style', `--collapsible-height: ${this.content.scrollHeight}px`);
       });
     });
     
     // start listening to changes
     myObserver.observe(this.inner);
  }
}

customElements.define('collapsible-content', CollapsibleContent);